import { apiGetUserFromOtp } from "../api/apiGetUserFromOtp";
import { personalDataFormSetFromModel, PERSONAL_DATA_FORM_FIELDS_NAMES } from "./personalDataForm";
import { supplyAddressSetFromModel } from "./supplyAddressForm";
import { removeBlankValuesObject } from "../utils/removeBlankValuesObject";
import { ROUTES } from "../utils/constants";
import { paymentRecapSetFromModel } from "./paymentRecap";
import { consentFormSetFromModel } from "./consentForm";
import { offerGetFromApi } from "./offer";
import { globalFormFieldsSet } from "./globalFormFields";
import { getUserId } from "../utils/getUserId";
import { blockingPopupSet } from "./blockingPopup";

export const getUserFromOtp = (otp, history) => {
    return async dispatch => {
        let user = await apiGetUserFromOtp(otp);
        if (!user.email) {
            dispatch(blockingPopupSet(true, 'Qualcosa è andato storto', 'Non siamo riusciti a risalire alla tua richiesta di sottoscrizione. Le motivazioni potrebbero essere:<br /> 1) la tua sottoscrizione è rimasta in sospeso per più di 7 giorni.<br /> 2) La tua sottoscrizione è stata bloccata da un nostro addetto.<br /> 3) La tua sottoscrizione è già stata completata.'));
            return history.push(ROUTES.home);
        }

        dispatch(globalFormFieldsSet('userId', getUserId(user.userId)));
        dispatch(globalFormFieldsSet('otp', otp));
        user = { 
            firstStep: removeBlankValuesObject(user.firstStep),
            secondStep: removeBlankValuesObject(user.secondStep),
            thirdStep: removeBlankValuesObject(user.thirdStep),
            fourthStep: removeBlankValuesObject(user.fourthStep),
            fifthStep: removeBlankValuesObject(user.fifthStep)
        };

        dispatch(personalDataFormSetFromModel(user));
        dispatch(supplyAddressSetFromModel(user));
        dispatch(paymentRecapSetFromModel(user));
        dispatch(consentFormSetFromModel(user));

        if (user.firstStep && user.firstStep[PERSONAL_DATA_FORM_FIELDS_NAMES.offerId]) {
            dispatch(offerGetFromApi({
                offerId: user.firstStep[PERSONAL_DATA_FORM_FIELDS_NAMES.offerId],
                offerType: user.firstStep[PERSONAL_DATA_FORM_FIELDS_NAMES.offerType],
                coupon: user.firstStep[PERSONAL_DATA_FORM_FIELDS_NAMES.couponCode],
            }));
        }

        // Cerca l'ultimo step finished
        if (user.secondStep.finished === "0" || !user.secondStep.finished) {
            return history.push(ROUTES.supply);
        } else if (user.thirdStep.finished === "0" || !user.thirdStep.finished) {
            return history.push(ROUTES.paymentRecap);
        } else if (user.fourthStep.finished === "0" || !user.fourthStep.finished) {
            return history.push(ROUTES.consents);
        } else if  (user.fifthStep.finished === "0" || !user.fifthStep.finished) {
            return history.push(ROUTES.recap);
        } else {
            return history.push(ROUTES.endPage);
        }
    }
}